import { render, staticRenderFns } from "./Settings-Password.vue?vue&type=template&id=551112b7&"
import script from "./Settings-Password.vue?vue&type=script&lang=js&"
export * from "./Settings-Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports